import {
  Activity,
  Binary,
  Box,
  Clock3,
  Database,
  Fuel,
  Gauge,
  Layers3,
  MoveUp,
  PersonStanding,
  RotateCw,
  Ruler,
  Scale,
  SquareDashed,
  Thermometer,
  Triangle,
  Waves,
  Zap,
} from 'lucide-react'

const icons = {
  acceleration: MoveUp,
  angle: Triangle,
  area: SquareDashed,
  data: Binary,
  density: Layers3,
  energy: Zap,
  force: PersonStanding,
  frequency: Waves,
  'fuel-economy': Fuel,
  length: Ruler,
  mass: Scale,
  power: Activity,
  pressure: Gauge,
  speed: Gauge,
  temperature: Thermometer,
  time: Clock3,
  torque: RotateCw,
  volume: Box,
  fallback: Database,
}

export default function CategoryIcon({ categoryId, size = 22, strokeWidth = 1.8 }) {
  const Icon = icons[categoryId] ?? icons.fallback
  return <Icon aria-hidden="true" size={size} strokeWidth={strokeWidth} />
}
